import { Prompt } from '@/components/MainContent';
import { createContext, FC, PropsWithChildren, useContext, useState } from 'react';

interface SearchProps {
  searchResults: Prompt[];
  setSearchResults: (value: Prompt[]) => void;
}

const SearchContext = createContext<SearchProps | undefined>(undefined);

export const SearchProvider: FC<PropsWithChildren> = ({ children }) => {
  const [searchResults, setSearchResults] = useState<Prompt[]>([]);

  return (
    <SearchContext.Provider value={{
      searchResults,
      setSearchResults,
    }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchContext must be used within a <SearchProvider>');
  }
  return context;
};
